import {
  preLoad
} from "../include/module";
import {
  anchorLink
} from "../include/module";
import {
  loadAnimate
} from "../include/module";
import {
  scrollAnimate
} from "../include/module";
import {
  resizeHeader
} from "../include/module";
import {
  moreBtn
} from "../include/module";
import {
  termToggle
} from "../include/module";
import {
  toggleMenu
} from "../include/module";
import {
  accordion
} from "../include/module";
import {
  bnr
} from "../include/module";


(() => {

  preLoad();
  anchorLink();
  loadAnimate();
  scrollAnimate();
  resizeHeader();
  moreBtn();
  termToggle();
  toggleMenu();
  accordion();
  bnr();
})();


// WEBPACK FOOTER //
// ./src/assets/js/audition/script.js